import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthSessionServiceDelegate } from '../../../authentication/services/delegate.auth.session.service';
import { AccessDeniedService } from '../../shared/services/access-denied.service';
import { Profile } from '../models/profile';
import { User } from '../models/user';
import { SessionConnectorService } from '../services/session-connector.service';
import { SessionService } from '../services/session.service';


@Component({
  selector: 'app-profiles',
  templateUrl: './profiles.component.html',
  styleUrls: ['./profiles.component.scss']
})
export class ProfilesComponent implements OnInit {

  constructor(
    private router: Router,
    private sessionConnector: SessionConnectorService,
    private session: SessionService,
    private authSession: AuthSessionServiceDelegate,
    private accessDeniedService: AccessDeniedService
  ) { }


  displayedColumns: string[] = ['siret', 'service', 'action'];
  profiles: Profile[];



  ngOnInit(): void {
    this.authSession.getProfiles().subscribe(data => {
      if (data) {
        if (data.profiles.length === 0) {
          this.accessDeniedService.unauthorized();
        }
        this.profiles = data.profiles;
        return this.profiles;
      }
    });
  }

  public connect(profile: Profile) {
    this.sessionConnector.connect(profile);
    this.router.navigate(['']);
  }

  private isProfilActif(profile: Profile) {
    const user = this.session.getUser();
    // TODO Fix HttpService.instanciate and use equals
    return user !== null && User.equals(user, profile.user)
  }
}
